module.exports = __webpack_public_path__ + "img/hero-bg.a26c05c2.jpg";